import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "icon", "onClick"];
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MenuContext } from '../../js/MenuContext';
import { MenuItemMixin } from '../../mixins/components/MenuItemMixin';
export var StyledMenuItem = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledMenuItem",
  componentId: "c11n-8-64-0__sc-1blp609-0"
})(["", ""], MenuItemMixin);
/**
 * Menu items are HTML buttons by default that close the
 * [`Menu`](#/Dialog%20components?id=menu) and take an action when
 * clicked.
 *
 * @since 7.28.0
 */

var MenuItem = function MenuItem(props) {
  var _useContext = useContext(MenuContext),
      onActivate = _useContext.onActivate;

  var children = props.children,
      icon = props.icon,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded);

  var onClickCallback = useCallback(function (e) {
    // Let `Menu` know the item was activated
    if (onActivate) {
      onActivate();
    } // Take the action


    if (onClick) {
      onClick(e);
    }
  }, [onActivate, onClick]);
  return /*#__PURE__*/React.createElement(StyledMenuItem, _extends({}, rest, {
    onClick: onClickCallback
  }), icon, children);
};

MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Item text content.
   */
  children: PropTypes.node.isRequired,

  /**
   * An optional [`Icon`](#/More%20components?id=icon) node.
   */
  icon: PropTypes.node,

  /**
   * The action to perform when the menu item is activated with a click or with keyboard
   * interaction.
   */
  onClick: PropTypes.func,

  /**
   * Menu items have the role of `"menuitem"` by default per the
   * [accesibility guidelines](https://www.w3.org/TR/wai-aria-practices-1.1/#wai-aria-roles-states-and-properties-13).
   */
  role: PropTypes.string
} : {};
MenuItem.defaultProps = {
  icon: undefined,
  onClick: undefined,
  role: 'menuitem'
};
/** @component */

export default MenuItem;